import { SVC_A } from './base'

export function getFormLettersForDomain (domainUUID) {
  return SVC_A.get(`/api/viewer-tools/v1/form-letter/${domainUUID}`)
}

export function captureScreenshot (cameraUUID, timestamp) {
  return SVC_A.getImage('/api/snapshot/v1/snapshot', `/${cameraUUID}/${timestamp}?w=350`)
}

export function getFormLetterPDF (formContent) {
  return SVC_A.download('/api/viewer-tools/v1/form-letter-pdf', '', formContent)
}

export function saveFormLetterTemplate (formContent) {
  return SVC_A.patch('/api/viewer-tools/v1/form-letter', formContent)
}

export function deactivateFormLetterTemplate (formLetterId, domainUUID) {
  return SVC_A.patch(`/api/viewer-tools/v1/form-letter`, { parent_id: formLetterId, domain_uuid: domainUUID })
}
